import React from "react";
import ButtonComponent from "@components/Button";
import { IoSync } from "react-icons/io5";
// import { RiRobot2Line } from "react-icons/ri";
const Cta = ({ openSyncWizard }: { openSyncWizard: () => void }) => {
  return (
    <div className="flex gap-4 items-center mb-4">
      <ButtonComponent
        onClick={openSyncWizard}
        leftIcon={IoSync}
        text="Share your first item"
        className="flex items-center text-sm font-semibold text-white shadow-sm"
      />

      {/* <ButtonComponent
        leftIcon={RiRobot2Line}
        text="Explore automation templates"
        className=" font-semibold text-[#323338] border border-[#d0d4e4] text-sm shadow-sm"
        kind="secondary"
      /> */}
    </div>
  );
};

export default Cta;
